import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#94A3B8",
      d: "M22 12.278c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      d: "m18 6.278-2.02 2.02m0 7.96 2.02 2.02M8.02 8.46 6 6.44m2.182 9.656-.445.444L6 18.278"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M16 12.278a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    }, null, -1)
  ])))
}
export default { render: render }